/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Activity_DeadlineInputs */

const en_reports_col_activity_deadline = /** @type {(inputs: Reports_Col_Activity_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity due date`)
};

const pt_br2_reports_col_activity_deadline = /** @type {(inputs: Reports_Col_Activity_DeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo Atividade`)
};

/**
* | output |
* | --- |
* | "Activity due date" |
*
* @param {Reports_Col_Activity_DeadlineInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_activity_deadline = /** @type {((inputs?: Reports_Col_Activity_DeadlineInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Activity_DeadlineInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_activity_deadline(inputs)
	return pt_br2_reports_col_activity_deadline(inputs)
});